module.exports = __webpack_public_path__ + "img/area_1.973a687d.png";